import { Stack } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryFallback from 'src/sections/error/error-boundary-fallback';
import { LoadingScreen } from 'src/components/loading-screen';
import { CandidateState } from './constants/constants-nav';
import {
  CandidateProfileContext,
  CandidateProfileProvider,
} from './context/candidate-profile-context';
import ProfileHeader from './profile-header';
import LeftContainer from './left-container';
import RightContainer from './right-container';
import CandidateProfileLayout from './layout';

const CandidateProfile = ({
  role,
  candidateType,
  candidateId,
  open,
  setOpen,
  jobId,
  currentCandidateIndex,
  totalCandidates,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  onClose: closeHandler,
  isLoading,
  setIsLoading,
  setShowCandidateProfile,
  needCodingAssessment,
  updateCandidateFlag,
  interactiveInterviewEnabled
}) => {
  // states
  const [navGroup, setNavGroup] = useState(CandidateState);

  // functions

  return (
    <ErrorBoundary key={candidateId} FallbackComponent={ErrorBoundaryFallback}>
      <CandidateProfileProvider
        candidateId={candidateId}
        jobId={jobId}
        candidateType={candidateType}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setShowCandidateProfile={setShowCandidateProfile}
        needCodingAssessment={needCodingAssessment}
        interactiveInterviewEnabled={interactiveInterviewEnabled}
      >
        <CandidateProfileLayout onClose={closeHandler} open={open}>
          <ProfileHeader
            totalCandidates={totalCandidates}
            candidateNumber={currentCandidateIndex}
            jobRole={role}
            onClose={closeHandler}
            onPrevious={onPrevious}
            onNext={onNext}
            hasPrevious={hasPrevious}
            hasNext={hasNext}
          />

          <CandidateProfileContext.Consumer>
            {value => {
              if (value.isLoading) {
                return (
                  <Stack
                    width="100%"
                    height="100%"
                    justifyContent="center"
                    alignItems="center"
                  >
                    Loading...
                  </Stack>
                );
              }
              return (
                <ErrorBoundary
                  key={`data-${candidateId}`}
                  FallbackComponent={ErrorBoundaryFallback}
                >
                  <Stack direction="row" overflow="hidden">
                    <LeftContainer
                      setNavGroup={setNavGroup}
                      jobId={jobId}
                      updateCandidateFlag={updateCandidateFlag}
                    />
                    <RightContainer
                      navGroup={navGroup}
                      setNavGroup={setNavGroup}
                      jobId={jobId}
                    />
                  </Stack>
                </ErrorBoundary>
              );
            }}
          </CandidateProfileContext.Consumer>
        </CandidateProfileLayout>
      </CandidateProfileProvider>
    </ErrorBoundary>
  );
};

export default CandidateProfile;

CandidateProfile.propTypes = {
  role: PropTypes.string,
  candidateId: PropTypes.string.isRequired,
  jobId: PropTypes.string,
  open: PropTypes.bool,
  currentCandidateIndex: PropTypes.number,
  totalCandidates: PropTypes.number,
  setOpen: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  hasPrevious: PropTypes.bool,
  hasNext: PropTypes.bool,
  onClose: PropTypes.func,
  candidateType: PropTypes.string,
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
  setShowCandidateProfile: PropTypes.func,
  needCodingAssessment: PropTypes.bool,
  updateCandidateFlag: PropTypes.func,
  interactiveInterviewEnabled: PropTypes.bool
};
